import { useEffect, useRef } from "react";
import { SHRIDAY } from "./Chart.config";
import { redJodi } from "../JodiCharts/Chart.config";
import { fa_time } from "../../Helpers/getWeekDays";

/* ---------- Skeleton Row ---------- */
const SkeletonRow = ({ colCount }) => (
  <tr>
    {Array.from({ length: colCount }).map((_, i) => (
      <td key={i} className="cc">
        <div className="tw-animate-pulse tw-h-8 tw-bg-gray-200 tw-rounded-md tw-m-1" />
      </td>
    ))}
  </tr>
);

const DAYS = ["MON","TUE","WED","THU","FRI","SAT","SUN"];

const ShreeDevi = ({ chartData }) => {

  const tableEndRef = useRef(null);
  const isApiLoading = !chartData || chartData.length === 0;

  /* ---------- dynamic days ---------- */
  const dynamicDaysCount =
    chartData?.[0]?.data?.filter(
      (item) => item?.relatedData?.[0]?.winningDigitFamily !== null
    ).length || 7;

  const visibleDays = DAYS.slice(0, dynamicDaysCount);
  const colCount = visibleDays.length + 1;

  useEffect(() => {
    tableEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chartData]);

  /* ---------- safe date format ---------- */
  const formatDate = (date) => {
    if (!date) return "";
    try {
      return fa_time(date);
    } catch {
      return date;
    }
  };

  return (
    <div>
      <table className="table fw-bold" border="collapse">
        <thead>
           <tr className="tw-text-center">
            <th className="cc">Date</th>

            {visibleDays.map((day) => (
              <th key={day} className="cc">
                {day}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>

          {/* ================= STATIC DATA ================= */}
          { Object.entries(SHRIDAY).map(([week, days], index) => {

                const [startDate, , endDate] = week.split(" ");

                return (
                  <tr key={index}>
                    <td className="cc td-width-13">
                      <div className="pana-chart-main">

                        <span className="result_date">
                          {formatDate(startDate)}
                        </span>

                        <span className="result_date">
                          to
                        </span>

                        <span className="result_date">
                          {formatDate(endDate)}
                        </span>

                      </div>
                    </td>

                    {Object.entries(days)
                      .slice(0, visibleDays.length)
                      .map(([day, values], id) => (

                        <td key={id} className="cc">

                          <div className="kalyan-chart-number-black">

                            {values.map((value, valueIndex) => {
                            const isAnyInRedJodi = values.some((value) =>
                              redJodi
                                .map((j) => parseInt(j))
                                .includes(parseInt(value)),
                            );
                            return (
                              <span
                                key={valueIndex}
                                className={`cp ${isAnyInRedJodi ? "text-danger" : "text-dark"}`}
                                style={{
                                  color: isAnyInRedJodi ? "red" : "black",
                                }}
                              >
                                {value ?? ""}
                              </span>
                            );
                          })}

                          </div>

                        </td>
                      ))}
                  </tr>
                );
              })}

          {/* ================= DYNAMIC DATA ================= */}
          {isApiLoading
            ? Array.from({ length: 3 }).map((_, i) => (
                <SkeletonRow key={`dynamic-skel-${i}`} colCount={colCount} />
              ))
            : chartData.map((item1) => {

                const filteredData = item1.data.filter(
                  (nestedItem) =>
                    nestedItem?.relatedData?.[0] &&
                    nestedItem.relatedData[0].winningDigitFamily !== null
                );

                if (filteredData.length === 0) return null;

                return (
                  <tr key={item1.id}>

                    <td className="cc td-width-13">
                      <div className="pana-chart-main">

                        <span className="result_date">
                          {formatDate(item1.weekStartDay)}
                        </span>

                        <span className="result_date">
                          to
                        </span>

                        <span className="result_date">
                          {formatDate(item1.weekEndDay)}
                        </span>

                      </div>
                    </td>

                    {filteredData
                      .slice(0, visibleDays.length)
                      .map((nestedItem) => {

                        const value0 =
                          nestedItem.relatedData?.[0]?.winningDigit ?? "";

                        const family0 =
                          nestedItem.relatedData?.[0]?.winningDigitFamily ?? "";

                        const family1 =
                          nestedItem.relatedData?.[1]?.winningDigitFamily ?? "";

                        const value1 =
                          nestedItem.relatedData?.[1]?.winningDigit ?? "";

                        const combinedValue = `${family0}${family1}`;

                        const isRed = redJodi
                          .map((j) => parseInt(j))
                          .includes(parseInt(combinedValue) || 0);

                        return (
                          <td key={nestedItem.id} className="cc">

                            <div className="kalyan-chart-number-black">

                              <span
                                className={`cp ${
                                  isRed ? "text-danger" : "text-dark"
                                }`}
                              >
                                {value0}
                              </span>

                              <span
                                className={`cp ${
                                  isRed ? "text-danger" : "text-dark"
                                }`}
                              >
                                {family0}
                                {family1}
                              </span>

                              <span
                                className={`cp ${
                                  isRed ? "text-danger" : "text-dark"
                                }`}
                              >
                                {value1}
                              </span>

                            </div>

                          </td>
                        );
                      })}
                  </tr>
                );
              })}

          <tr ref={tableEndRef} />

        </tbody>
      </table>
    </div>
  );
};

export default ShreeDevi;